import React, { useEffect, useState } from "react";
import {
  getAllGeneralLedger,
  getAllItemsSearch,
  getAllSupplierSearch,
} from "../../api/endpoints/search";
import { authSelector } from "../../store/selectors/index";
import { useSelector } from "react-redux";
import { Modal, message, Select } from "antd";
import { AiFillSave } from "react-icons/ai";
import { AiFillDelete } from "react-icons/ai";
import { LuView } from "react-icons/lu";
import { AiFillEdit } from "react-icons/ai";
import { AiFillFileAdd } from "react-icons/ai";
import { BiExit } from "react-icons/bi";
import SideBar from "../sidebar/sideBar";
import "./bulkPurchase.css";
import Popup from "../modals/Popup";
import {
  getVoucher,
  saveData,
  getData,
  updatePurchase,
  deleteInvoivce,
} from "../../api/endpoints/bulkPurchase.js";
import { getTankById } from "../../api/endpoints/tank";
const { Option } = Select;

const BulkPurchase = () => {
  const { user, access_token } = useSelector(authSelector);
  const [fieldsShow, setFieldsShow] = useState(false);
  const [editPopup, setEditpopup] = useState(false);
  const [datePopup, setDatepopup] = useState(false);
  const [deletePopup, setDeletepopup] = useState(false);
  const [type, setType] = useState("ADD");
  const [state, setState] = useState({
    id: "",
    items: [],
    ledgerCodes: [],
    parties: [],
    tanks: [],
    glCode: "",
    glDescription: "",
    tank: "",
    itemCode: "",
    itemName: "",
    partyId: "",
    partyName: "",
    purchaseVoucherNo: "",
    enteredOn: "",
    shift: "",
    quantity: "",
    purchaseRate: "",
    saleRate: "",
    creditAmount: "",
  });

  const clearState = () => {
    setState({
      id: "",
      ledgerCodes: state.ledgerCodes,
      parties: state.parties,
      items: state.items,
      tanks: state.tanks,
      glCode: "",
      glDescription: "",
      tank: "",
      itemCode: "",
      itemName: "",
      partyId: "",
      partyName: "",
      purchaseVoucherNo: "",
      enteredOn: "",
      shift: "",
      quantity: "",
      purchaseRate: "",
      saleRate: "",
      creditAmount: "",
    });
  };

  console.log(state, "Vall");

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };
  const addTank = async () => {
    setDatepopup(true);
  };
  const addPurchase = async () => {
    if (!state.enteredOn) return message.error("Please type date !");
    const payload = {
      enteredOn: state.enteredOn,
    };
    setDatepopup(false);
    const result = await getVoucher(payload, access_token);
    console.log(result, "result");
    if (result.success) {
      //   setIsVisible(false);
      setState({
        ...state,
        purchaseVoucherNo: result.data,
      });
      setType("SAVE");
      setFieldsShow(true);
    } else {
      message.error(result.message);
    }
  };
  //   console.log(state.generalLedgerCode.length,"leng")
  const savePurchase = async () => {
    if (
      !state.enteredOn ||
      !state.shift ||
      !state.itemCode ||
      !state.partyId ||
      !state.glCode ||
      !state.quantity ||
      !state.creditAmount ||
      !state.purchaseRate ||
      !state.saleRate
    ) {
      return message.error(
        `Please type ${
          !state.itemCode
            ? "item"
            : !state.glCode
            ? "GL code"
            : !state.partyId
            ? "Party Id"
            : !state.quantity
            ? "quantity"
            : !state.creditAmount
            ? "Credit amount"
            : !state.enteredOn
            ? "Date"
            : !state.shift
            ? "Shift"
            : !state.purchaseRate
            ? "Purchase Rate"
            : !state.saleRate
            ? "Sale Rate"
            : ""
        }`
      );
    }
    const payload = {
      enteredOn: state.enteredOn,
      shift: Number(state.shift),
      partyId: Number(state.partyId),
      itemCode: state.itemCode,
      quantity: Number(state.quantity),
      purchaseRate: Number(state.purchaseRate),
      creditAmount: Number(state.creditAmount),
      tankNumber: state.tank,
      generalLedgerCode: state.glCode,
      saleRate: Number(state.saleRate),
      purchaseVoucherNo: Number(state.purchaseVoucherNo),
      grpId: Number(user.grpId),
      siteId: Number(user.siteId),
      companyCode: Number(user.companyCode),
    };

    console.log(payload, "payload");

    const results = await saveData(payload, access_token);
    if (results.success) {
      message.success(results.message || "Successfully entered!");
      clearState();
      setFieldsShow(false);
      setType("ADD");
    } else {
      message.error(results.message);
    }
  };

  const editTank = async () => {
    setEditpopup(true);
  };
  const editHandler = async () => {
    if (!state.purchaseVoucherNo)
      return message.error("Please type Voucher Number !");

    setEditpopup(false);
    const result = await getData(state.purchaseVoucherNo, access_token);
    console.log(result, "result");
    if (result.success) {
      //   setIsVisible(false);
      setState({
        ...state,
        id: result.data.id,
        enteredOn: result.data.enteredOn,
        itemName: result.data.item.itemName,
        partyName: result.data.party.partyName,
        glDescription: result.data.chartOfAccount.description,
        shift: Number(result.data.shift),
        partyId: Number(result.data.partyId),
        itemCode: result.data.itemCode,
        quantity: Number(result.data.quantity),
        purchaseRate: Number(result.data.purchaseRate),
        creditAmount: Number(result.data.creditAmount),
        tankNumber: result.data.tank,
        glCode: result.data.generalLedgerCode,
        saleRate: Number(result.data.saleRate),
        purchaseVoucherNo: Number(result.data.purchaseVoucherNo),
      });
      setType("EDIT");
      setFieldsShow(true);
    } else {
      message.error(result.message);
    }
  };
  const deleteHandler = async () => {
    if (!state.purchaseVoucherNo)
      return message.error("Please type Voucher Number !");

    setDeletepopup(false);
    const result = await getData(state.purchaseVoucherNo, access_token);
    console.log(result, "result");
    if (result.success) {
      //   setIsVisible(false);
      setState({
        ...state,
        id: result.data.id,
        enteredOn: result.data.enteredOn,
        itemName: result.data.item.itemName,
        partyName: result.data.party.partyName,
        glDescription: result.data.chartOfAccount.description,
        shift: Number(result.data.shift),
        partyId: Number(result.data.partyId),
        itemCode: result.data.itemCode,
        quantity: Number(result.data.quantity),
        purchaseRate: Number(result.data.purchaseRate),
        creditAmount: Number(result.data.creditAmount),
        tankNumber: result.data.tank,
        glCode: result.data.generalLedgerCode,
        saleRate: Number(result.data.saleRate),
        purchaseVoucherNo: Number(result.data.purchaseVoucherNo),
      });
      setType("DELETE");
      setFieldsShow(true);
    } else {
      message.error(result.message);
    }
  };

  const saveEditTank = async (e) => {
    if (type === "EDIT") {
      if (
        !state.enteredOn ||
        !state.shift ||
        !state.itemCode ||
        !state.partyId ||
        !state.glCode ||
        !state.quantity ||
        !state.creditAmount ||
        !state.purchaseRate ||
        !state.saleRate
      ) {
        return message.error(
          `Please type ${
            !state.itemCode
              ? "item"
              : !state.glCode
              ? "GL code"
              : !state.partyId
              ? "Party Id"
              : !state.quantity
              ? "quantity"
              : !state.creditAmount
              ? "Credit amount"
              : !state.enteredOn
              ? "Date"
              : !state.shift
              ? "Shift"
              : !state.purchaseRate
              ? "Purchase Rate"
              : !state.saleRate
              ? "Sale Rate"
              : ""
          }`
        );
      }
      const data = {
        id: state.id,
        purchaseVoucherNo: Number(state.purchaseVoucherNo),
        enteredOn: state.enteredOn,
        shift: Number(state.shift),
        partyId: Number(state.partyId),
        itemCode: state.itemCode,
        quantity: Number(state.quantity),
        purchaseRate: Number(state.purchaseRate),
        creditAmount: Number(state.creditAmount),
        tankNumber: state.tank,
        generalLedgerCode: state.glCode,
        saleRate: Number(state.saleRate),
      };
      console.log(data, "edite data");
      const results = await updatePurchase(data, access_token);
      if (results.success) {
        message.success(results.message || "Successfully Updated!");
        clearState();
        setFieldsShow(false);
        setType("ADD");
      } else {
        message.error(results.message);
      }
    } else {
      if (!state.purchaseVoucherNo)
        return message.error("Please Type Voucher Number");
      modal.confirm({
        title: `Confirm`,
        content: "Are you sure you want to delete this Invoice?",
        okText: "Delete",
        cancelText: "Cancel",
        onOk: confirmDeleteNozel,
      });
    }
  };
  const confirmDeleteNozel = async () => {
    const results = await deleteInvoivce(state.purchaseVoucherNo, access_token);
    if (results.success) {
      message.success(results.message || "Deleted Successfully!");
      clearState();
      setFieldsShow(false);
      setType("ADD");
    } else {
      message.error(results.message);
    }
  };

  const [modal, contextHolder] = Modal.useModal();
  const deleteNozel = async () => {
    setDeletepopup(true);
  };
  const confirmDelete = () => {
    // setEditpopup(true);
    modal.confirm({
      title: `Confirm`,
      content: "You want to delete Invoice?",
      okText: "Yes",
      cancelText: "Cancel",
      onOk: deleteNozel,
    });
  };

  const clearStates = () => {
    clearState();
    setFieldsShow(false);
    setType("ADD");
  };

  const getAllData = async () => {
    const _items = await getAllItemsSearch(access_token);
    const _parties = await getAllSupplierSearch(access_token);
    const _ledgerCodes = await getAllGeneralLedger(access_token);
    setState({
      ...state,
      items: _items,
      parties: _parties,
      ledgerCodes: _ledgerCodes,
    });
  };
  useEffect(() => {
    getAllData();

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getTankByCode = async () => {
    const data = await getTankById(state.itemCode, access_token);
    if (data.success) {
      setState({
        ...state,
        tanks: data.data,
        tank: data.data[0].tankNumber,
      });
    }
  };

  useEffect(() => {
    if (state.itemCode) {
      getTankByCode();
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.itemCode]);

  console.log(state, "state");
  return (
    <>
      <div className="flex bg-black main">
        <SideBar />
        <div className="h-full  flex flex-col content-center  w-full">
          <div className="flex justify-center">
            <div className="meterTableMain flex flex-col justify-items-center justify-center w-1/2 ml-10 mt-5 mr-10">
              <div className="bg-blue-500 headingBox flex justify-center">
                <h1 className="text-white">BULK PURCHASE</h1>
                {contextHolder}
              </div>
              <div className="p-2 flex justify-center">
                {fieldsShow && (
                  <div className="w-70">
                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white" htmlFor="fname">
                          Voucher Number:
                        </label>
                        <input
                          readOnly
                          type="number"
                          name="purchaseVoucherNo"
                          value={state.purchaseVoucherNo}
                          className="bg-black text-slate-400 pl-2 inpTxt h-8 w-full"
                        />
                      </div>
                      <div className="w-1/2 mb-3">
                        <label className="text-white ml-3" htmlFor="fname">
                          Date :
                        </label>
                        <input
                          type="date"
                          name="enteredOn"
                          value={state.enteredOn}
                          onChange={onChangeText}
                          className="bg-black  text-slate-400 inpTxtDate p-2 h-8 w-full ml-3"
                        />
                      </div>
                      <div className="w-1/2 ml-3 mb-3">
                        <label className="text-white ml-3" htmlFor="fname">
                          Shift :
                        </label>
                        <input
                          type="text"
                          name="shift"
                          value={state.shift}
                          onChange={onChangeText}
                          className="bg-black text-slate-400 inpTxt ml-3 p-2 h-8 w-full"
                        />
                      </div>
                    </div>
                    <div className="flex justify-evenly w-full">
                      {/* <div className="w-1/2 mb-3">
                        <label className="text-white ml-3" htmlFor="fname">
                          Bill Time :
                        </label>
                        <Select
                          showSearch
                          className="text-black inpTxt  h-9 w-full ml-3"
                          placeholder=""
                          optionFilterProp="children"
                          value={state.billTime || "Monthly"} // Set to "Monthly" if state.billTime is falsy
                          onChange={(value) => {
                            onChangeText({
                              target: { name: "billTime", value },
                            });
                          }}
                        >
                          <Option value={"Monthly"} name="billTime">
                            Monthly
                          </Option>
                          <Option value={"Fortnightly"} name="billTime">
                            Fortnightly
                          </Option>
                        </Select>
                      </div> */}
                    </div>
                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white " htmlFor="fname">
                          Item :
                        </label>
                        <Select
                          showSearch
                          placeholder="Select item"
                          className="bg-black text-slate-400 inpTxt h-8 w-full "
                          optionFilterProp="children"
                          value={state.itemCode || "Item"}
                          onChange={(e) => {
                            const { itemName } = state.items.find(
                              (el) => el.itemCode === e
                            );
                            setState({
                              ...state,
                              itemCode: e,
                              itemName: itemName,
                            });
                          }}
                        >
                          {state.items.map((el) => (
                            <Option value={el.itemCode}>{el.itemCode}</Option>
                          ))}
                        </Select>
                      </div>
                      <div className="w-1/2 mb-3">
                        <label className="text-white ml-3" htmlFor="fname">
                          Item Name :
                        </label>
                        <Select
                          showSearch
                          placeholder="Select Item Name"
                          optionFilterProp="children"
                          className="bg-black text-slate-400 inpTxt h-8 ml-3 w-full"
                          value={state.itemName || "Item Name"}
                          onChange={(e) => {
                            const { itemName } = state.items.find(
                              (el) => el.itemCode === e
                            );
                            setState({
                              ...state,
                              itemCode: e,
                              itemName: itemName,
                            });
                          }}
                        >
                          {state.items.map((el) => (
                            <Option value={el.itemCode}>{el.itemName}</Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white " htmlFor="fname">
                          Supplier Id :
                        </label>
                        <Select
                          showSearch
                          placeholder="A/C No."
                          className="text-black inpTxt  h-9 w-full"
                          optionFilterProp="children"
                          value={state.partyId || "A/C No."}
                          onChange={(e) => {
                            console.log("e", e);

                            const _party = state.parties.find(
                              (el) => el.partyId === e
                            );
                            if (_party) {
                              setState({
                                ...state,
                                partyId: e,
                                partyName: _party.PartyName,
                                glCode: _party.chartOfAccount.generalLedgerCode,
                                glDescription:
                                  _party.chartOfAccount.description,
                              });
                            } else {
                              setState({
                                ...state,
                                partyId: e,
                                partyName: "",
                                glCode: "",
                                glDescription: "",
                              });
                            }
                          }}
                        >
                          <Option value={0}>None</Option>
                          {state.parties.map((el) => (
                            <Option
                              value={el.partyId}
                            >{`${el.partyId} - ${el.PartyName}`}</Option>
                          ))}
                        </Select>
                      </div>
                      <div className="w-1/2 mb-3">
                        <label className="text-white ml-3" htmlFor="fname">
                          Supplier Name :
                        </label>
                        <Select
                          showSearch
                          className="text-black inpTxt  h-9 w-full ml-3"
                          placeholder="Supplier Name"
                          optionFilterProp="children"
                          value={state.partyName || "Supplier Name"}
                          onChange={(e) => {
                            const { PartyName, chartOfAccount } =
                              state.parties.find((el) => el.partyId === e);
                            setState({
                              ...state,
                              partyId: e,
                              partyName: PartyName,
                              glCode: chartOfAccount.generalLedgerCode,
                              glDescription: chartOfAccount.description,
                            });
                          }}
                        >
                          {state.parties.map((el) => (
                            <Option value={el.partyId}>{el.PartyName}</Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white" htmlFor="fname">
                          GL Description :
                        </label>
                        <Select
                          showSearch
                          disabled={Boolean(state.glCode)}
                          className="text-black p-1 bg-black inpTxt  h-9 w-full"
                          placeholder="GL Description"
                          optionFilterProp="children"
                          value={state.glDescription || "GL Description "}
                          onChange={(e) => {
                            const lCode = state.ledgerCodes.find(
                              (el) => el.generalLedgerCode === e
                            );
                            setState({
                              ...state,
                              glCode: e,
                              glDescription: lCode.description,
                            });
                          }}
                        >
                          {state.ledgerCodes.map((el) => (
                            <Option value={el.generalLedgerCode}>
                              {el.description}
                            </Option>
                          ))}
                        </Select>
                      </div>
                      <div className="w-1/2 mb-3">
                        <label className="text-white ml-3" htmlFor="fname">
                          GL Code :
                        </label>
                        <Select
                          disabled={Boolean(state.glCode)}
                          showSearch
                          className="text-black inpTxt p-1 bg-black h-9 w-full ml-3"
                          placeholder="Credit GL Code"
                          optionFilterProp="children"
                          value={state.glCode || "Credit GL Code"}
                          onChange={(e) => {
                            const lCode = state.ledgerCodes.find(
                              (el) => el.generalLedgerCode === e
                            );
                            setState({
                              ...state,
                              glCode: e,
                              glDescription: lCode.description,
                            });
                          }}
                        >
                          {state.ledgerCodes.map((el) => (
                            <Option value={el.generalLedgerCode}>
                              {el.generalLedgerCode}
                            </Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white " htmlFor="fname">
                          Quantity :
                        </label>
                        <input
                          type="number"
                          name="quantity"
                          value={state.quantity}
                          onChange={(e) => {
                            if (state.purchaseRate) {
                              setState({
                                ...state,
                                creditAmount:
                                  e.target.value * state.purchaseRate,
                                quantity: e.target.value,
                              });
                            } else {
                              setState({ ...state, quantity: e.target.value });
                            }
                          }}
                          className="bg-black text-slate-400 pl-2 inpTxt h-8 w-full "
                        />
                      </div>
                      <div className="w-1/2 mb-3">
                        <label className="text-white ml-3" htmlFor="fname">
                          P/Rate :
                        </label>
                        <input
                          type="number"
                          name="purchaseRate"
                          value={state.purchaseRate}
                          onChange={(e) => {
                            if (state.quantity) {
                              setState({
                                ...state,
                                creditAmount: e.target.value * state.quantity,
                                purchaseRate: e.target.value,
                              });
                            } else {
                              setState({
                                ...state,
                                purchaseRate: e.target.value,
                              });
                            }
                          }}
                          className="bg-black text-slate-400 inpTxt pl-2 h-8 ml-3 w-full"
                        />
                      </div>
                      <div className="w-1/2 ml-3 mb-3">
                        <label className="text-white ml-3" htmlFor="fname">
                          Sale Rate :
                        </label>
                        <input
                          type="text"
                          name="saleRate"
                          value={state.saleRate}
                          onChange={onChangeText}
                          className="bg-black text-slate-400 inpTxt pl-2 h-8 ml-3 w-full"
                        />
                      </div>
                      <div className="w-1/2 ml-3 mb-3">
                        <label className="text-white ml-3" htmlFor="fname">
                          Amount :
                        </label>
                        <input
                          type="number"
                          name="creditAmount"
                          value={state.creditAmount}
                          onChange={(e) => {
                            if (state.quantity) {
                              setState({
                                ...state,
                                purchaseRate: e.target.value / state.quantity,
                                creditAmount: e.target.value,
                              });
                            } else {
                              setState({
                                ...state,
                                creditAmount: e.target.value,
                              });
                            }
                          }}
                          className="bg-black text-slate-400 inpTxt pl-2 h-8 ml-3 w-full"
                        />
                      </div>
                    </div>
                    <div className="w-1/2 mb-3">
                      <label className="text-white" htmlFor="fname">
                        Tank:
                      </label>
                      <Select
                        showSearch
                        placeholder="Tank"
                        optionFilterProp="children"
                        className="text-black inpTxt  h-9 w-full"
                        value={state.tank || "Tank"}
                        onChange={(e) => {
                          setState({ ...state, tank: e });
                        }}
                      >
                        {state.tanks.map((el) => (
                          <Option value={el.tankNumber}>{el.tankNumber}</Option>
                        ))}
                      </Select>
                    </div>
                  </div>
                )}
              </div>
              <div class="flex justify-center pb-3">
                {type === "ADD" && (
                  <button
                    onClick={addTank}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 py-1 px-4 rounded"
                  >
                    <AiFillFileAdd className="mr-2 mt-1" />

                    <span>Add</span>
                  </button>
                )}

                {type === "SAVE" && (
                  <button
                    onClick={savePurchase}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 py-1 px-4 rounded"
                  >
                    <AiFillSave className="mt-1 mr-2 " />
                    <span>Save</span>
                  </button>
                )}
                {type === "ADD" && (
                  <button className="bg-blue-500 hover:bg-blue-700 flex text-white ml-2 mt-3 py-1 px-4 rounded">
                    <LuView className="mt-1 mr-2 " />
                    <span>View</span>
                  </button>
                )}
                {type === "ADD" && (
                  <button
                    onClick={editTank}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                  >
                    <AiFillEdit className="mr-2 mt-1" />

                    <span>Edit</span>
                  </button>
                )}

                {(type === "EDIT" || type === "DELETE") && (
                  <button
                    onClick={saveEditTank}
                    className="bg-blue-500 hover:bg-blue-700 text-white ml-2 mt-3 py-1 px-4 rounded"
                  >
                    DONE
                  </button>
                )}
                {type === "ADD" && (
                  <button
                    onClick={confirmDelete}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                  >
                    <AiFillDelete className="mr-2 mt-1" />

                    <span>Delete</span>
                  </button>
                )}
                {type !== "ADD" && (
                  <button
                    onClick={clearStates}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                  >
                    <BiExit className="mr-2 mt-1" />
                    <span>Exit</span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <Popup popup={datePopup} handlePopup={setDatepopup} onOk={addPurchase}>
          <div>
            <h2>Please type Date</h2>
            <input
              type="date"
              name="enteredOn"
              value={state.enteredOn}
              onChange={onChangeText}
              className="bg-slate-100 text-slate-400 inpTxt p-2 w-1/2 h-8 ml-3"
            />
          </div>
        </Popup>
        <Popup popup={editPopup} handlePopup={setEditpopup} onOk={editHandler}>
          <div>
            <h2>Please type Voucher Number</h2>
            <input
              type="number"
              name="purchaseVoucherNo"
              value={state.purchaseVoucherNo}
              onChange={onChangeText}
              className="bg-slate-100 text-black inpTxt p-2 w-1/2 h-8 ml-3"
            />
          </div>
        </Popup>
        <Popup
          popup={deletePopup}
          handlePopup={setDeletepopup}
          onOk={deleteHandler}
        >
          <div>
            <h2>Please type Voucher Number</h2>
            <input
              type="number"
              name="purchaseVoucherNo"
              value={state.purchaseVoucherNo}
              onChange={onChangeText}
              className="bg-slate-100 text-black inpTxt p-2 w-1/2 h-8 ml-3"
            />
          </div>
        </Popup>
      </div>
    </>
  );
};

export default BulkPurchase;
